package diana.soleil.design.iraniancanadienbazzar.core.devmenu

import org.koin.core.module.Module
import org.koin.dsl.module

/**
 * DI for the Developer Menu. The [DevMenuRegistry] is a singleton so features can contribute [DevTool]s.
 * `AppBuildInfo` is provided by the composition root (it carries the platform's real build metadata), not
 * here — this module only owns the registry.
 */
val devMenuModule: Module = module {
    single { DevMenuRegistry() }
}
